// Feste Grund-Listen fürs Callcenter — nach Häufigkeit sortiert (Sharina,
// Juli 2026, aus den wöchentlichen Excel-Auswertungen). Jede Liste endet auf
// REASON_OTHER als Freitext-Fallback ("Sonstiges").
import { REASON_OTHER } from './salesTalk';

export { REASON_OTHER };

export const CANCEL_REASONS = [
  'Krank',
  'Kein Interesse mehr',
  'Termin dazwischen gekommen',
  'Passt zeitlich doch nicht',
  'Weg ist doch zu weit',
  'Verletzung',
  'Zu teuer / kennt Preis',
  'Bleiben doch beim alten Sport',
  'Anderer Standort passt besser',
  'Kein Grund angegeben',
  REASON_OTHER,
] as const;

export const RESCHEDULE_REASONS = [
  'Krank',
  'Termin dazwischen gekommen',
  'Verletzung',
  'Anderer Standort passt besser',
  'Kein Grund angegeben',
  REASON_OTHER,
] as const;

// Für Anrufe, bei denen von vornherein kein Termin vereinbart werden konnte.
export const NOT_SCHEDULED_REASONS = [
  'Zeiten passen nicht',
  'Geschwister können nicht zusammen trainieren',
  'Weg ist zu weit',
  'Sportart wird nicht angeboten',
  'Zu teuer',
  'Kommunikation nicht möglich',
  'Beantwortet Qualifragen nicht',
  'Nicht erreichbar',
  'Kein Interesse mehr',
  'Respektlos/Unfreundlich',
  REASON_OTHER,
] as const;

// Warum eine Anfrage storniert wird. Nicht zu verwechseln mit CANCEL_REASONS —
// dort geht es um einen abgesagten Probetermin, hier um eine gegenstandslose
// Anfrage. Der Kunde bleibt in beiden Fällen bestehen.
//
// Destiny, 19.08.2026: „Ich wollte eine Anfrage löschen, weil im Telefonat
// rauskam, dass sich die Kundin doppelt eingebucht hat."
export const LEAD_CANCEL_REASONS = [
  'Dublette — dieselbe Person hat mehrfach angefragt',
  'Testeintrag',
  'Versehentlich abgeschickt',
  'Falsche Kontaktdaten / nicht zuzuordnen',
  'Anfrage über anderen Weg schon erledigt',
  REASON_OTHER,
] as const;
